import { theme, SignOutIcon, Loader } from "kosmos-ui/lib";

import { useSignOutShopperMutation } from "api/graphql/mutations/shopper/hooks";
import { SHOPPER_BROWSER_SIDEBAR_SECTIONS } from "../../constants";

import { getSidebarIconColors } from "./helpers";
import {
  ShopperBrowserSidebarContainer,
  ShopperBrowserSectionContainer,
} from "./styles";
import { TShopperBrowserSidebarProps } from "./types";

export default function ShopperBrowserSidebar({
  show,
  activeSection,
  onSectionChange,
}: TShopperBrowserSidebarProps) {
  const [signOutShopperMutation, { loading: loadingSignOutShopperMutation }] =
    useSignOutShopperMutation();

  function handleSignOutShopperClick(
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) {
    event.preventDefault();
    event.stopPropagation();

    signOutShopperMutation();
  }

  return (
    <ShopperBrowserSidebarContainer show={show}>
      {SHOPPER_BROWSER_SIDEBAR_SECTIONS.map((section) => {
        return (
          <ShopperBrowserSectionContainer
            key={section._id}
            selected={activeSection === section._id}
            onClick={() => onSectionChange(section._id)}
          >
            <section.icon
              height="18px"
              style={{ marginRight: 8 }}
              {...getSidebarIconColors(activeSection === section._id)}
            />

            {section.label}
          </ShopperBrowserSectionContainer>
        );
      })}

      <ShopperBrowserSectionContainer
        selected={false}
        onClick={handleSignOutShopperClick}
      >
        <SignOutIcon
          height="16px"
          style={{ marginRight: 8, color: theme.colorsPalette.gray.light }}
        />
        {loadingSignOutShopperMutation ? <Loader /> : "Cerrar sesión"}
      </ShopperBrowserSectionContainer>
    </ShopperBrowserSidebarContainer>
  );
}
